import { render, staticRenderFns } from "./ImgFallback2.vue?vue&type=template&id=c17a467c&"
import script from "./ImgFallback2.vue?vue&type=script&lang=js&"
export * from "./ImgFallback2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c17a467c')) {
      api.createRecord('c17a467c', component.options)
    } else {
      api.reload('c17a467c', component.options)
    }
    module.hot.accept("./ImgFallback2.vue?vue&type=template&id=c17a467c&", function () {
      api.rerender('c17a467c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2DJzdC5HEaPRb/JS/comp/ImgFallback2.vue"
export default component.exports